import gql from "graphql-tag";

export const queryReportData = gql`
query ent ($id:String, $input : AuthInput, $sectionName:String) {
  getReportData (reportId: $id, input: $input, sectionName: $sectionName)
  {
            id
            title
            tenantId
            botAppId
            jobId
            integrationId
            widget
            text
            type
            kpi
            startDate
            endDate
            tForm
            valueType
            reportSend
            reportMail
            conversationType
            problemTypes
            emailAttachmentFormat
            pstnNumber
            dtmfStartDate
            dtmfEndDate
            jobType
            {
                intervalMonth
                intervalDay
                intervalHour
                intervalMinute
                intervalType
                jobStartTime
            }
            categories
            alarming {
                mail
                eventType
                value
                alarmActive
            }
            position {
                w
                h
                x
                y
            }
            cycle
            keywords
            data {
                overflow
                text
                color
                name
                type
                user {
                   userId 
                   items {
                     value
                     args
                     total
                   }
                }
                total {
                    value
                    args
                    hit
                    noHit
                }
                time {
                    time
                    inbound
                    outbound
                    meeting
                    intern
                    recorded
                    total
                    error
                    totalLoss
                    onlySilence
                    onlyTranscript
                    lessDuration
                    packetLoss
                    irretrievableCall
                    msftInviteError
                    chat
                    upload
                    hit
                    noHit
                    users {
                        userId
                        value
                    }
                    items {
                        args
                        value
                    }
                     processing
                     single
                     ongoing
                     otherUser
                     audioLoss
                     processingError
                     noTranscript
                     errorTranscript
                     videoLoss
                     noError
                }
                keymap {
                    name
                    items {
                        value
                        name
                    }
                }
                settingItems{
                    name
                    maxRange
                    minRange
                    color
                }
            }
          }
        }

    `;
export const checkMailForDomainRestrictions = gql`
                         mutation ent ($auth:AuthInput, $email: String){
                            checkMailForDomainRestrictions(input:$auth, email: $email)
                                   
                              }
                            `;

export const getAvailableExportJobList = gql`
    query getAvailableExportJobList($auth:AuthInput){
        getAvailableExportJobList(input:$auth)
            {
            tenantId
            jobList{
                jobId
                jobName
                }
            }
        }
        `;

export const getAvailableImportJobList = gql`
    query getAvailableImportJobList($auth:AuthInput){
        getAvailableImportJobList(input:$auth)
            {
            tenantId
            jobList{
                jobId
                jobName
                }
            }
        }
        `;
export const queryGetDashboards = gql`
     query ent ($input : AuthInput, $type: String) {
                    getDashboards (input: $input, type: $type) {
                        id
                        title
                        users
                        user
                        managers
                        isOwner
                        isManager
                        hasEntryListAccess
                        hasEntryListDownload 
                    }
                }
        `;

export const setPinnedDashboard = gql`
                         mutation ent ($auth:AuthInput,$dashboardId:String){
                            setPinnedDashboard(input:$auth,dashboardId:$dashboardId)
                              }
                            `;

export const getSectionKpi = gql`
query ent ($input:AuthInput, $reportId:String, $sectionName:String){
    getSectionKpi(
        input: $input,
        reportId: $reportId,
        sectionName: $sectionName
    ) {
        id
        title
        text
        widget
        type
        cycle
        startDate
        endDate
        kpi
        keywords
        sortOrder
        valueType
        tenantId
        botAppId
        jobId
        integrationId
        tForm
        categories
        dashboard
        reportSend
        reportMail
        conversationType
        problemTypes
        emailAttachmentFormat
        data {
            text
            overflow
            color
            type
            name
            user {
                userId
                value
                items {
                    value
                    args
                    hit
                    noHit
                }
            }
            settingItems {
                name
                maxRange
                minRange
                color
            }
            keymap {
                name
                items {
                    value
                    name
                }
            }
            time {
                inbound
                outbound
                meeting
                intern
                unknown
                total
                recorded
                no
                noStart
                error
                time
                totalLoss
                onlySilence
                onlyTranscript
                noTranscript
                errorTranscript
                lessDuration
                packetLoss
                callTry
                processing
                processingError
                noError
                single
                ongoing
                otherUser
                audioLoss
                videoLoss
                irretrievableCall
                msftInviteError
                chat
                upload
                hit
                noHit
            }
            total {
                value
                args
                hit
                noHit
            }
        }
        persons {
            id
            userId
            tenantId
            name
            members
        }
    }
}`;
export const queryDeleteDtmfEntry = gql`
        mutation DeleteDtmfEntry($id: String, $pstnNumber: String) {
            deleteDtmfEntry(id: $id, pstnNumber: $pstnNumber) {
            id
        }
      }
    `;